// Generated by ReScript, PLEASE EDIT WITH CARE


function reducer(state, action) {
  switch (action.TAG | 0) {
    case /* SetMap */0 :
        return {
                map: action._0,
                mapCenter: state.mapCenter,
                showMarker: state.showMarker,
                selectedAddress: state.selectedAddress,
                geoPostalAddress: state.geoPostalAddress
              };
    case /* SetMapCenter */1 :
        return {
                map: state.map,
                mapCenter: action._0,
                showMarker: state.showMarker,
                selectedAddress: state.selectedAddress,
                geoPostalAddress: state.geoPostalAddress
              };
    case /* SetShowMarker */2 :
        return {
                map: state.map,
                mapCenter: state.mapCenter,
                showMarker: action._0,
                selectedAddress: state.selectedAddress,
                geoPostalAddress: state.geoPostalAddress
              };
    case /* SetSelectedAddress */3 :
        return {
                map: state.map,
                mapCenter: state.mapCenter,
                showMarker: state.showMarker,
                selectedAddress: action._0,
                geoPostalAddress: state.geoPostalAddress
              };
    case /* SetGeoPostalAddress */4 :
        return {
                map: state.map,
                mapCenter: state.mapCenter,
                showMarker: state.showMarker,
                selectedAddress: state.selectedAddress,
                geoPostalAddress: action._0
              };
    
  }
}

function getInitialState(address, geoPostalAddress, mapCenter) {
  return {
          map: null,
          mapCenter: mapCenter,
          showMarker: false,
          selectedAddress: address,
          geoPostalAddress: geoPostalAddress
        };
}

export {
  reducer ,
  getInitialState ,
}
/* No side effect */
